export default {
  colors: {
    primary: "#154f87",
    secondary: "#8acbe5",
    tertiary: "hotpink",
    quaternary: "hotpink",
    quinary: "#D05012;",
  }
}
